<template>
  <div v-if="loading" class="d-grid h-100 bg-dark" style="place-content: center">
    <IndeterminateSpinner class="h1 m-0 text-white"/>
  </div>
  <div v-else class="w-100 d-flex flex-grow-1">
    <PresentationControl/>
    <SideBar class="d-flex flex-grow-1 bg-dark"  />
    <ConnectionIndicator ></ConnectionIndicator>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex"
import PresentationControl from "./PresentationControl.vue"
import visibility from "@/lib/visibility";
import SideBar from "./sidebar/SideBar.vue"
import ConnectionIndicator from "../frontend/shared/ConnectionIndicator.vue";
import apiClient from "../../entrypoints/frontend/apiClient.js";
import IndeterminateSpinner from "@/components/backend/live/IndeterminateSpinner.vue";

export default {
  name: 'Live',
  components: {IndeterminateSpinner, ConnectionIndicator, SideBar, PresentationControl},
  data() {
    return { loading: true };
  },
  computed: {
    ...mapState(['election', 'slides']),
    ...mapGetters(['activeSlide', "firstAvailableLocale"]),
    ballotSlides(){
      return this.slides.filter(s => s.type === 'Slides::BallotSlide')
    },
    visible(){
      return visibility.visible;
    }
  },
  methods: {
    ...mapActions(['updateStatus', 'updatePosts', 'fetchLiveResult','ensureLastUpdateCounts', 'checkWebsocketConnection', "subscribeToElectionChannel"]),
    ...mapActions('timing', ['checkTime']),
    ...mapMutations(['goToSlide', 'setProgress', 'setResult', 'setBallotState', 'closeBallot', 'resetBallot', 'setCounts', 'createItem', 'updateItem', 'deleteItem']),
  },
  watch: {
    visible: function(newState, oldState){
      if(newState){
        this.updateStatus(true);
        this.updatePosts();
      }
    }
  },
  created() {
    this.checkTime();
  },
  mounted(){
    Promise.all([
      this.updateStatus(true),
      this.updatePosts(),
    ]).then(()=>{
      this.loading = false;
    });
    this.subscribeToElectionChannel(true);

    this.connectiontimer = setInterval(() => {
      this.checkWebsocketConnection()
    }, 1000)
  },
  beforeUnmount() {
    clearInterval(this.connectiontimer)
  }
}
</script>